import styled from 'styled-components';

import backgroundImage from '../../img/login-background.png';

export const PageWrapper = styled.div`
    height: 100vh;
    
    background-image: url(${backgroundImage});
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;

    padding-left: 132px;
    padding-top: 40px;

    @media(max-width: 852px) {
        padding-left: 0;
        padding-top: 24px;
    }

`;

export const ContentWrapper = styled.div`
    max-width: 588px;

    display: flex;
    flex-direction: column;
    align-items: center;

    @media(max-width: 852px) {
        margin: 0 auto;
    }

    @media(max-width: 620px) {
        margin: 0 16px;
    }
`;

export const LogoContainer = styled.div`
    max-width: 440px;
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: space-between;

    margin-bottom: 24px;

    img {
        max-width: 195px;
        max-height: 78px;
    }

    img + img {
        max-width: 202px;
        max-height: 52px;
    }

    @media(max-width: 620px) {
        img {
            max-width: 120px;
        }

        img + img {
            max-width: 120px;
        }
    }
`;

export const WelcomeContainer = styled.div`
    max-width: 480px;

    display: flex;
    justify-content: space-between;

    @media(max-width: 852px) {
        display: none;
    }

    img {
        max-height: 180px;
        margin-right: 4px
    }

    div {
        background-color: #0E4C54;
        color: #ffffff;
        max-width: 348px;
        margin-top: 32px;
        padding: 14px;
        border-radius: 10px 0px;
        align-self: flex-start;
        position: relative;

        span {
            background-color: #0E4C54;
            display: block;
            height: 2px;
            width: 32px;
            position: absolute;
            top: 26px;
            left: -32px;
        }
    
        h3 {
            font-size: 18px;
            line-height: 24px;
            font-weight: 700;
        }

        p {
            color: #ffffff;
            font-size: 14px;
            line-height: 18px;
            width: 100%auto;
        }
    }
`;

export const ContentContainer = styled.div`
    background-color: #ffffff;
    padding: 18px 30px;
    border-radius: 10px 0px 0px 0px;

    @media(max-width: 852px) {
        padding: 10px 16px;
    }
    
    .w-100 {
        width: 100%;
    }

    .inline-flex {
        display: inline-flex;
    }

    .action-button {
        background: #0E4C54;
    }

    .form-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 0px 16px;
    }

    @media(max-width: 852px) {
        .form-grid {
            grid-template-columns: 1fr;
        }
    }
`;
